export default __webpack_public_path__ + "9daacd63411c6929c6ca73768543cca7.png";